module.exports = "https://cdn-challenge.mathletics.com/app/288/assets/fonts/ad546b4719bcf690a3604944b90b7e42.woff2";